import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-timestamp-list-dialog',
  templateUrl: './timestamp-list-dialog.component.html',
  styleUrls: ['./timestamp-list-dialog.component.scss']
})
export class TimestampListDialogComponent implements OnInit {
  totalMoney: number;
  totalFlie = 0;
  nzData= []
  signType: number;
  constructor(
    public dialogRef: MatDialogRef<TimestampListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.nzData = data.verifyPriceDetails
    console.log(this.nzData);
    this.totalFlie = this.data.mainContractAttachments.length
   }

  ngOnInit() {
    // debugger
    this.totalMoney = this.nzData.reduce((sum, item) => { return sum + Number(item.money); }, 0)
    if (this.nzData[0].hasOwnProperty('signType')) {
      this.signType = this.nzData[0].signType;
    }
    else {
      this.signType = -1;
    }
  }

  onClickCancelButton(){
    this.dialogRef.close()
  }

}
